import React, { FC, PropsWithChildren } from 'react'
import {
  StyledClickable,
  StyledClickableProps,
} from '../StyledClickable/StyledClickable'

type ButtonProps = StyledClickableProps & {
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
}

export const Button: FC<PropsWithChildren<ButtonProps>> = ({
  children,
  size,
  appearance = 'text',
  type,
  ...restProps
}) => {
  return (
    <StyledClickable
      size={size}
      appearance={appearance}
      type={type}
      {...restProps}
    >
      {children}
    </StyledClickable>
  )
}
